import { TextInputField } from "@sainsburys-tech/luna-form";
import { Form, CheckboxField } from "@sainsburys-tech/luna-form";
import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC } from "react";
import {
  AutomationAdaptoSystemOptions,
  FIELDS,
  FormInputLevels,
  HazardousCodeOptions,
  MUTypeOptions,
} from "../../../Interfaces/Product/IProductFormField";
import { ProductFormProps } from "../../../Types/Product/ProductFormProps";
import ActionButton from "../../SharedComponents/ActionButton";
import { useSelector } from "react-redux";
import { SelectField } from "@sainsburys-tech/luna-form";
import { UI_CONSTANTS } from "../../../Constants/constants";
import { ProductValueType } from "../../../Types/Product/ProductValueType";
import { ProductError } from "../../../Types/Product/ProductError";
import { packSizeToDisplay } from "./FormHelper/productValueTypeFields";

const AttributeForm: FC<ProductFormProps> = (props) => {
  const values = props.values as ProductValueType;
  const errors: ProductError | null | undefined = props.errors && props.errors as ProductError;

  const emptyReplacer = (key: any, value: any) => {
    if (value === "") {
      return null;
    }
    return value;
  };

  const payload = useSelector((state: any) => state.popupReducer);
  const isInitialState =
    JSON.stringify(payload?.data?.editPayload?.values, emptyReplacer) ===
    JSON.stringify(values, emptyReplacer);

  return (
    <Container>
      <Form className="o-form">
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.sainId.name}
              label={FormInputLevels.SainId}
              maxLength={128}
              value={values.sainId}
              error={errors?.sainId}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name="displayItemNumber"
              label={FormInputLevels.DisplayItemNumber}
              value={
                values.skuNumber
                  ? values.skuNumber
                  : values.catNumber
              }
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.description.name}
              label={FormInputLevels.Description}
              maxLength={128}
              value={values.description}
              error={errors?.description}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.packSize.name}
              label={FormInputLevels.PackSize}
              value={packSizeToDisplay(values)}
              disabled
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <SelectField
              name={FIELDS.muType.name}
              label={FormInputLevels.MUType}
              options={MUTypeOptions}
              defaultValue={values.muType}
              onChange={props.onChange}
              onBlur={props.onBlur}
              placeholder="NONE"
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <CheckboxField
              label={<p></p>}
              outlined
              name={FIELDS.uglies.name}
              options={[{ value: "Uglies", label: FormInputLevels.Uglies }]}
              defaultChecked={values.uglies}
              onClick={(e: any) => {
                props.onChange(e, "", "", true);
              }}
              fullWidth
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <CheckboxField
              label={<p></p>}
              name={FIELDS.twoPersonLift.name}
              outlined
              options={[
                {
                  value: "TwoPersonLift",
                  label: FormInputLevels.TwoPersonLift,
                },
              ]}
              defaultChecked={values.twoPersonLift}
              onClick={(e: any) => {
                props.onChange(e, "", "", true);
              }}
              fullWidth
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <CheckboxField
              label={<p></p>}
              name={FIELDS.hazardous.name}
              outlined
              options={[
                { value: "Hazardous", label: FormInputLevels.Hazardous },
              ]}
              defaultChecked={values.hazardous}
              onClick={(e: any) => {
                props.onChange(e, "", "", true);
              }}
              fullWidth
            />
          </GridItem>

          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <SelectField
              name={FIELDS.hazardousCode.name}
              label={FormInputLevels.HazardousCode}
              options={HazardousCodeOptions}
              defaultValue={values.hazardousCode}
              value={values.hazardousCode}
              onChange={props.onChange}
              onBlur={props.onBlur}
              disabled={!values.hazardous}
              placeholder="NONE"
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <CheckboxField
              label={<p></p>}
              name={FIELDS.nestedItem.name}
              outlined
              options={[
                {
                  value: "NestedItem",
                  label: FormInputLevels.NestedItem,
                },
              ]}
              defaultChecked={values.nestedItem}
              onClick={(e: any) => {
                props.onChange(e, "", "", true);
              }}
              fullWidth
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.nestIncrement.name}
              label={FormInputLevels.NestIncrement}
              maxLength={128}
              value={values.nestIncrement}
              error={errors?.nestIncrement}
              onBlur={props.onBlur}
              onChange={props.onChange}
              disabled={!values.nestedItem}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <SelectField
              name={FIELDS.automationAdaptoSystem.name}
              label={FormInputLevels.AutomationAdaptoSystem}
              options={AutomationAdaptoSystemOptions}
              defaultValue={values.automationAdaptoSystem}
              value={values.automationAdaptoSystem}
              onChange={props.onChange}
              onBlur={props.onBlur}
              placeholder="NONE"
            />
          </GridItem>

          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.automationToteFill.name}
              label={FormInputLevels.AutomationToteFill}
              maxLength={128}
              value={values.automationToteFill}
              error={errors?.automationToteFill}
              onBlur={props.onBlur}
              onChange={props.onChange}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.automationMinTotes.name}
              label={FormInputLevels.AutomationMinTotes}
              maxLength={128}
              value={values.automationMinTotes}
              error={errors?.automationMinTotes}
              onBlur={props.onBlur}
              onChange={props.onChange}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <CheckboxField
              label={<p></p>}
              name={FIELDS.highRisk.name}
              className="checkBoxOrange"
              outlined
              options={[
                {
                  value: "HighRisk",
                  label: FormInputLevels.HighRisk,
                },
              ]}
              defaultChecked={values.highRisk}
              disabled
              fullWidth
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <CheckboxField
              label={<p></p>}
              name={FIELDS.strapTotes.name}
              className="checkBoxOrange"
              z
              outlined
              options={[
                {
                  value: "StrapTotes",
                  label: FormInputLevels.StrapTotes,
                },
              ]}
              defaultChecked={values.strapTotes}
              disabled
              fullWidth
            />
          </GridItem>
          {values.alias === UI_CONSTANTS.ARGOS && (

            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <CheckboxField
                label={<p></p>}
                name={FIELDS.expiryDateRequired.name}
                outlined
                options={[
                  {
                    value: "ExpiryDateRequired",
                    label: FormInputLevels.ExpiryDateRequired,
                  },
                ]}
                defaultChecked={values.expiryDateRequired}
                onClick={(e: any) => {
                  props.onChange(e, "", "", true);
                }}
                fullWidth
              />
            </GridItem>
          )}
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <CheckboxField
              label={<p></p>}
              name={FIELDS.pickPack.name}
              outlined
              options={[
                {
                  value: "PickPack",
                  label: FormInputLevels.PickPack,
                },
              ]}
              defaultChecked={values.pickPack}
              onClick={(e: any) => {
                props.onChange(e, "", "", true);
              }}
              fullWidth
            />
          </GridItem>
        </GridWrapper>
      </Form>

      <ActionButton
        onSubmit={props.onSubmit}
        onClearAll={props.onClearAll}
        onCancel={props.onCancel}
        isAddDisabled={isInitialState}
        isDirty={props.dirty}
        isEdit={props.isEdit}
        isClearButtonRequired={false}
        submitted={props.submitted}
      />
    </Container>
  );
};

export default AttributeForm;
